module.exports = __webpack_public_path__ + "assets/2_3_1_IFOK_WIM_STUSTAINABILITY_Godd_work_Platform_for_svg_je.1b552cb9.svg";